(() => {
  'use strict';
  if (window.gdDropCardCarouselReady) return;
  window.gdDropCardCarouselReady = true;
  const narrow = window.matchMedia('(max-width: 989px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.gd-drop-skin [data-gd-card-carousel]';
  const suppressed = new WeakMap();
  const settling = new WeakMap();
  let drag = null;
  let touch = null;

  function dots(track, index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))) {
    track.parentElement?.querySelectorAll('[data-gd-card-dot]').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  }

  function restoreSnap(track, state) {
    if (settling.get(track) !== state) return;
    clearTimeout(state.timer);
    settling.delete(track);
    track.style.scrollSnapType = state.snap;
  }

  function stopSettling(track) {
    const previous = settling.get(track);
    if (previous) {
      clearTimeout(previous.timer);
      settling.delete(track);
      track.scrollTo({ left: track.scrollLeft, behavior: 'instant' });
    }
    return previous;
  }

  function settle(track, snap, target, index) {
    const state = { track, snap, target };
    settling.set(track, state);
    state.timer = setTimeout(() => {
      if (settling.get(track) !== state) return;
      track.scrollTo({ left: target, behavior: 'instant' });
      restoreSnap(track, state);
    }, 700);
    track.scrollTo({ left: target, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    if (Math.abs(track.scrollLeft - target) < 1) restoreSnap(track, state);
    dots(track, index);
  }

  function finish(event) {
    if (!drag || (event && event.pointerId !== drag.id)) return;
    const state = drag;
    drag = null;
    state.endLeft = state.track.scrollLeft;
    state.track.classList.remove('is-dragging');
    if (state.track.hasPointerCapture?.(state.id)) state.track.releasePointerCapture(state.id);
    if (!state.moved) { state.track.style.scrollSnapType = state.snap; return; }
    suppressed.set(state.track, Date.now() + 700);
    const width = Math.max(state.track.clientWidth, 1);
    const firstIndex = Math.round(state.left / width);
    let index = Math.round(state.endLeft / width);
    const distance = state.endLeft - state.left;
    if (index === firstIndex && Math.abs(distance) > Math.max(24, width * 0.18)) index += Math.sign(distance);
    index = Math.max(0, Math.min(state.track.children.length - 1, index));
    settle(state.track, state.snap, index * width, index);
  }

  document.addEventListener('pointerdown', event => {
    const track = event.target.closest?.(selector);
    if (!track || !narrow.matches || event.pointerType !== 'mouse' || event.button !== 0 || track.children.length < 2) return;
    suppressed.delete(track);
    const previous = stopSettling(track);
    drag = { track, id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, snap: previous ? previous.snap : track.style.scrollSnapType, moved: false };
  });
  document.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.moved) {
      if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { finish(event); return; }
      if (Math.abs(dx) < 8) return;
      drag.moved = true;
      drag.track.style.scrollSnapType = 'none';
      drag.track.classList.add('is-dragging');
      drag.track.setPointerCapture?.(event.pointerId);
    }
    event.preventDefault();
    drag.track.scrollLeft = drag.left - dx;
  }, { passive: false });
  document.addEventListener('pointerup', finish);
  document.addEventListener('pointercancel', finish);
  document.addEventListener('lostpointercapture', finish);
  function cancelTouch() {
    if (!touch) return;
    touch.track.style.scrollSnapType = touch.snap;
    touch = null;
  }
  document.addEventListener('touchstart', event => {
    if (event.touches.length !== 1) { cancelTouch(); return; }
    const track = event.target.closest?.(selector);
    if (!track || !narrow.matches || track.children.length < 2) return;
    const previous = stopSettling(track);
    const point = event.touches[0];
    touch = { track, id: point.identifier, x: point.clientX, y: point.clientY, lastX: point.clientX, lastTime: event.timeStamp, velocity: 0, left: track.scrollLeft, snap: previous ? previous.snap : track.style.scrollSnapType, horizontal: false };
  }, { passive: true });
  document.addEventListener('touchmove', event => {
    if (!touch) return;
    if (event.touches.length !== 1) { cancelTouch(); return; }
    const point = event.touches[0];
    const dx = point.clientX - touch.x, dy = point.clientY - touch.y;
    if (!touch.horizontal) {
      if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx) * 1.15) { cancelTouch(); return; }
      if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
      touch.horizontal = true;
      touch.track.style.scrollSnapType = 'none';
    }
    const elapsed = event.timeStamp - touch.lastTime;
    if (elapsed > 0) touch.velocity = (point.clientX - touch.lastX) / elapsed;
    touch.lastX = point.clientX;
    touch.lastTime = event.timeStamp;
  }, { passive: true });
  document.addEventListener('touchend', event => {
    if (!touch) return;
    if (event.touches.length) { cancelTouch(); return; }
    const state = touch;
    touch = null;
    const point = [...event.changedTouches].find(item => item.identifier === state.id);
    if (!point || !state.horizontal) { state.track.style.scrollSnapType = state.snap; return; }
    const width = Math.max(state.track.clientWidth, 1);
    const dx = point.clientX - state.x;
    const flick = event.timeStamp - state.lastTime <= 100 && Math.abs(state.velocity) >= 0.35 && Math.abs(dx) >= 12;
    let index = Math.round(state.left / width);
    if (Math.abs(dx) >= Math.max(24, width * 0.18) || flick) index += dx < 0 ? 1 : -1;
    index = Math.max(0, Math.min(state.track.children.length - 1, index));
    suppressed.set(state.track, Date.now() + 700);
    settle(state.track, state.snap, index * width, index);
  }, { passive: true });
  document.addEventListener('touchcancel', cancelTouch, { passive: true });
  document.addEventListener('click', event => {
    const track = event.target.closest?.(selector);
    if (!track || !event.detail || (suppressed.get(track) || 0) < Date.now()) return;
    suppressed.delete(track);
    event.preventDefault();
    event.stopPropagation();
  }, true);
  document.addEventListener('dragstart', event => {
    if (narrow.matches && (drag || event.target.closest?.(selector))) event.preventDefault();
  });
  document.addEventListener('scroll', event => {
    if (!event.target.matches?.(selector)) return;
    dots(event.target);
    const state = settling.get(event.target);
    if (state && Math.abs(event.target.scrollLeft - state.target) < 1) restoreSnap(event.target, state);
  }, { passive: true, capture: true });
  window.addEventListener('resize', () => { if (!narrow.matches) finish(); });
})();
